/* ============================================================
   FleetPro RETAIL - mobile menu "you are here" (Phase 2).
   On a collection/product page, open the mobile drawer accordion to the
   user's current location and bring it into view. Keys off the native
   `.current` link, so it works regardless of whether link.active
   server-rendered or the theme's accordion JS collapses on init.
   Tapping a row navigates normally (native behaviour); the chevron button
   expands the submenu (native theme handler). This script only pre-opens
   the current branch + scrolls to it. Never scrolls the page.
   Loaded via header-main-menu.liquid (same place as fp-menu.css).
   ============================================================ */
(function () {
  function scrollParent(el) {
    var p = el.parentElement;
    while (p && p !== document.body && p !== document.documentElement) {
      var oy = getComputedStyle(p).overflowY;
      if (oy === 'auto' || oy === 'scroll') return p;
      p = p.parentElement;
    }
    return null; /* never return the page scroller */
  }

  function openToCurrent() {
    var nm = document.querySelector('.navigation-mobile');
    if (!nm) return;
    var cur = nm.querySelector('a.current') || nm.querySelector('a[aria-current="page"]');
    if (!cur) return;
    var li = cur.closest('.navigation-mobile-item');
    while (li) {
      if (li.querySelector(':scope > ul.navigation-sub-menu')) {
        li.classList.add('menu-item-expanded');
        var btn = li.querySelector(':scope > .navigation-mobile-item-link > .navigation-mobile-item-link-expand');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      }
      var par = li.parentElement;
      li = par ? par.closest('.navigation-mobile-item') : null;
    }
    var sc = scrollParent(cur);
    if (sc) {
      try {
        var top = cur.getBoundingClientRect().top - sc.getBoundingClientRect().top + sc.scrollTop;
        sc.scrollTop = Math.max(0, top - sc.clientHeight / 2);
      } catch (e) {}
    }
  }

  function run() {
    openToCurrent();
    setTimeout(openToCurrent, 60); /* re-apply once after theme init */
  }

  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run);
})();

/* ============================================================
   FleetPro RETAIL - desktop mega menu disclosure.
   Top-level pillars open only after an intentional click. Hover remains a
   visual preview state and never changes panel visibility. The active panel
   closes from the same trigger, its close button, an outside click, Escape,
   or when keyboard focus leaves the desktop navigation.
   ============================================================ */
(function () {
  if (window.__fpMegaClickBound) return;
  window.__fpMegaClickBound = true;

  var desktop = window.matchMedia('(min-width: 990px)');

  function closeItem(item) {
    if (!item) return;
    var trigger = item.querySelector(':scope > [data-fp-mega-trigger]');
    var panel = item.querySelector(':scope > [data-fp-mega-panel]');
    item.classList.remove('is-mega-open');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
    if (panel) panel.setAttribute('aria-hidden', 'true');
  }

  function closeAll(except) {
    var openItems = document.querySelectorAll('.navigation-main > .fp-nav-pillar.is-mega-open');
    openItems.forEach(function (item) {
      if (item !== except) closeItem(item);
    });
  }

  function openItem(item) {
    if (!item) return;
    var trigger = item.querySelector(':scope > [data-fp-mega-trigger]');
    var panel = item.querySelector(':scope > [data-fp-mega-panel]');
    if (!trigger || !panel) return;
    closeAll(item);
    item.classList.add('is-mega-open');
    trigger.setAttribute('aria-expanded', 'true');
    panel.setAttribute('aria-hidden', 'false');
  }

  function toggleItem(item) {
    if (item.classList.contains('is-mega-open')) closeItem(item);
    else openItem(item);
  }

  function initMenu(menu) {
    if (menu.dataset.fpMegaClickInit) return;
    menu.dataset.fpMegaClickInit = '1';

    var triggers = menu.querySelectorAll(':scope > .fp-nav-pillar > [data-fp-mega-trigger]');
    triggers.forEach(function (trigger) {
      var item = trigger.closest('.fp-nav-pillar');
      closeItem(item);
      trigger.addEventListener('click', function () {
        if (!desktop.matches) return;
        toggleItem(item);
      });
      trigger.addEventListener('keydown', function (event) {
        if (!desktop.matches || (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar')) return;
        event.preventDefault();
        toggleItem(item);
      });
    });

    menu.addEventListener('click', function (event) {
      var closeButton = event.target.closest('[data-fp-mega-close]');
      if (!closeButton) return;
      var item = closeButton.closest('.fp-nav-pillar');
      var trigger = item && item.querySelector(':scope > [data-fp-mega-trigger]');
      closeItem(item);
      if (trigger) trigger.focus();
    });

    menu.addEventListener('focusin', function (event) {
      var openItem = menu.querySelector(':scope > .fp-nav-pillar.is-mega-open');
      if (openItem && !openItem.contains(event.target)) closeItem(openItem);
    });

    menu.addEventListener('focusout', function () {
      window.setTimeout(function () {
        if (!menu.contains(document.activeElement)) closeAll();
      }, 0);
    });
  }

  function boot() {
    document.querySelectorAll('.navigation-main').forEach(initMenu);
  }

  document.addEventListener('pointerdown', function (event) {
    if (!event.target.closest('.navigation-main')) closeAll();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var item = document.querySelector('.navigation-main > .fp-nav-pillar.is-mega-open');
    if (!item) return;
    var trigger = item.querySelector(':scope > [data-fp-mega-trigger]');
    closeItem(item);
    if (trigger) trigger.focus();
    event.preventDefault();
  });

  function handleViewport(event) {
    if (!event.matches) closeAll();
  }
  if (desktop.addEventListener) desktop.addEventListener('change', handleViewport);
  else desktop.addListener(handleViewport);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
